import { connectInternalApi } from './api'

type User = {
  _id: string
  first_name: string
  last_name: string
  blocked?: boolean
  deleted?: boolean
  archived?: boolean
}

export const getUsers = async (accountId: string) => {
  const result = await connectInternalApi.get<User[]>(
    `v1/core/monorail/accounts/${accountId}/users`
  )

  return result.data
}
